export const getFromLS = (itemName: string, key?: string): any => {
  let ls: Record<string, any> = {};
  if (global.localStorage) {
    try {
      const storageItem = global.localStorage.getItem(itemName);
      ls = storageItem ? JSON.parse(storageItem) : {};
    } catch (e) {
      console.log(e);
    }
  }

  if (key) {
    return ls[key];
  } else {
    return ls;
  }
};

export const saveToLS = (itemName: string, key: string | null, value: any) => {
  if (global.localStorage) {
    if (key !== null) {
      global.localStorage.setItem(
        itemName,
        JSON.stringify({
          [key]: value,
        })
      );
    } else {
      global.localStorage.setItem(itemName, JSON.stringify(value));
    }
  }
};
